import trim from 'lodash/trim';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'trimText'
})
export class TrimTextPipe implements PipeTransform {
  transform(text = ''): string {
    return trim(text);
  }
}
